// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Hywb","containerItemsCenter":"Skeleton_containerItemsCenter__pObvn"};